/**
 * Block lookup helpers used inside the dashboard editor.
 */
export default class DashboardBlockHelper {
    /**
     * Resolve a block recursively by reference id.
     */
    static getBlock(blocks, referenceId) {
        if (!Array.isArray(blocks) || !referenceId) {
            return null;
        }

        for (const block of blocks) {
            if (block.referenceId === referenceId) {
                return block;
            }

            const childBlocks = Array.isArray(block.blocks) ? block.blocks : [];
            const childResult = this.getBlock(childBlocks, referenceId);

            if (childResult) {
                return childResult;
            }
        }

        return null;
    }
}
